import VeeValidate, { Validator } from 'vee-validate';

export default function setupCityRule() {
  Validator.extend('city_name', {
    getMessage: () => 'woonplaats waarde is ongeldig',
    validate: value => {
        if (!value || value.trim() === '') return true;
        return /^[a-zA-Z'\s\-]+$/u.test(value.trim());
    }
  });
}


// WEBPACK FOOTER //
// ./src/rules/city_name.js